<template>
  <div class="bg-white">
    <div class="flex justify-between">
      <div class="flex">
        <span class="flex-none font-semibold text-black-soft text-xl pt-1">
          {{ reasonTitle }}
        </span>
        <img :src="reasonIcon" :alt="exampleText" class="ml-4 relative reason-icon pt-1">
      </div>
    </div>
    <p class="mt-5 text-lg leading-loose">

      <template v-if="reasonTitle === reasonLabels.UNKNOWN_INTENT">
        The example was not recognized at all. It would be answered as
        <!-- hack: wrong intent id is '__unknown' and platformId just 'unknown', will work if unknown intent will have platformId 'unknown'-->
        <router-link :to="`/bots/${botId}/answers/${wrongAnswer.id}`">
          {{ `"${wrongAnswer.name}"` }}
        </router-link>
        by the bot.
      </template>

      <template v-else-if="reasonTitle === reasonLabels.LOW_CONFIDENCE">
        The answer
        <router-link :to="`/bots/${botId}/answers/${correctAnswer.id}`">{{ correctAnswer.name }}</router-link>
        was correctly recognized but with very low confidence.
      </template>

      <template v-else>
        The example was mis-categorized as answer:
        <router-link :to="`/bots/${botId}/answers/${wrongAnswer.id}`"
        >
          {{ wrongAnswer.name }}</router-link>.
        <br/>Expected answer:
        <router-link :to="`/bots/${botId}/answers/${correctAnswer.id}`" class="text-lg leading-loose">
          {{ correctAnswer.name }}</router-link>.
      </template>

    </p>
    <expandable-text-box :text="exampleText" class="mt-5"/>
  </div>
</template>

<script>
import testReportModule from '@/store/modules/test-report.module'
import ExpandableTextBox from '@/components/common/ExpandableTextBox'
import answerModule from '@/store/modules/answer.module'

export default {
  name: 'AnswersReportExampleDetailTop',

  components: { ExpandableTextBox },

  props: {
    reasonIcons: {
      type: Object,
      default: () => {}
    },
    reasonLabels: {
      type: Object,
      default: () => {}
    },
    botId: {
      type: String,
      default: ''
    }
  },

  computed: {
    selectedExample: testReportModule.getSelectedExample,
    selectedIntent: testReportModule.getSelectedIntent,
    answerList: answerModule.getAnswerList,

    reasonTitle() {
      return this.reasonLabels[this.selectedExample?.reason]
    },

    reasonIcon() {
      return this.reasonIcons[this.reasonTitle]
    },

    exampleText() {
      return this.selectedExample?.example || ''
    },

    correctAnswer() {
      return this.getAnswerByPlatformId(this.selectedIntent?.intent_platform_id) || {}
    },

    wrongAnswer() {
      return this.getAnswerByPlatformId(this.selectedExample?.wrong_intent) || {}
    }
  },

  methods: {
    getAnswerByPlatformId(platformId) {
      const formattedPlatformId = platformId === '__unknown' ? 'unknown' : platformId
      return this.answerList.find(({ intent }) => intent.platformId === formattedPlatformId)
    }
  }
}
</script>
